module.exports = __webpack_public_path__ + "img/endtwo.9fc79fdf.png";